export const GreenCheckIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00066 1.33203C4.32732 1.33203 1.33398 4.32537 1.33398 7.99871C1.33398 11.672 4.32732 14.6654 8.00066 14.6654C11.674 14.6654 14.6673 11.672 14.6673 7.99871C14.6673 4.32537 11.674 1.33203 8.00066 1.33203Z"
        fill="#067647"
      />
      <path
        d="M7.40631 10.245L11.1863 6.46495C11.3796 6.26495 11.3796 5.95162 11.1863 5.75828C10.993 5.56495 10.673 5.56495 10.4796 5.75828L7.05297 9.18495L5.51964 7.65162C5.3263 7.45828 5.0063 7.45828 4.81297 7.65162C4.61964 7.84495 4.61964 8.16495 4.81297 8.35829L6.69964 10.245C6.79297 10.3383 6.91964 10.3916 7.05297 10.3916C7.18631 10.3916 7.31297 10.3383 7.40631 10.245Z"
        fill="#ECFDF3"
      />
    </svg>
  )
}
